// Site-wide bundle, loaded in <head> on every main-site page
// (see _includes/head.html). Import order mirrors the old sprockets
// bundle: jQuery's global must exist before materialize evaluates.
// The translation review snapshot comes first of all: a page in the review
// app's frame lists its nodes before anything else here can change them.
import { reviewFrame } from "../src/review-frame/snapshot"
import "../src/jquery"
import * as Turbo from "@hotwired/turbo"
import "../src/materialize"
import GLightbox from "glightbox"
import Swiper from "swiper"
import { Application } from "stimulus"
import "../src/vendor/cornerpopup"
import { configureHoneybadger } from "../src/honeybadger"

import DownloadController from "../src/controllers/download"
import DownloadSectionController from "../src/controllers/download-section"
import PricingController from "../src/controllers/pricing"
import OSController from "../src/controllers/osdetector"
import LinuxController from "../src/controllers/linux"
import GatewayController from "../src/controllers/gateway"
import ExitController from "../src/controllers/exit"
import TrackerController from "../src/controllers/tracker"
import AnalyticsController from "../src/controllers/analytics"
import ModalController from "../src/controllers/modal"
import ExpanderController from "../src/controllers/expander"
import BlogModalController from "../src/controllers/blog-modal"
import VideosController from "../src/controllers/videos"
import ClipboardController from "../src/controllers/clipboard"
import SalesQualifierController from "../src/controllers/sales-qualifier"
import AutoplayVideoController from "../src/controllers/autoplay-video"
import LanguageSuggestController from "../src/controllers/language-suggest"
import TestimonialFormController from "../src/controllers/testimonial-form"
import TestimonialFilterController from "../src/controllers/testimonial-filter"
import PluginDirectoryController from "../src/controllers/plugin-directory"
import VideoPlayController from "../src/controllers/video-play"

// The old vendored build exposed the Turbo global.
window.Turbo = Turbo

// In the translation review app the app follows links, as both pages.
Turbo.session.drive = !reviewFrame
Turbo.setProgressBarDelay(0)

// Turbo swaps the <body> but leaves <html> alone, so after a visit from a
// translated page (/es/get) to an English-only one (/testimonials) the
// document would still say lang="es-MX" to assistive tech and translation
// prompts until a full reload. base.html puts the page's language on the
// body; copy it up before each render.
document.addEventListener('turbo:before-render', (event) => {
  const lang = event.detail.newBody?.dataset?.lang
  if (lang) document.documentElement.lang = lang
})

// Work around a Turbo 8.0.23 bug. When a Turbo visit can't render the new
// page (its data-turbo-track assets differ, e.g. main-layout -> the CSV SQL
// tool), Turbo sets session.view.forceReloaded and falls back to a full
// page load, and its pagehide handler hands scroll restoration back to the
// browser. Neither is ever undone, which is harmless while that document is
// thrown away. But Firefox (and Chrome, when eligible) can restore it from
// the back/forward cache, and from then on every Turbo visit skips scrolling
// to the top: pages open at the previous page's scroll offset. Undo both
// when a page comes back from the back/forward cache.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return
  Turbo.session.view.forceReloaded = false
  Turbo.session.history.assumeControlOfScrollRestoration()
})

// Header Scroll
window.addEventListener('scroll', () => {
  document.querySelector('.header').classList[window.scrollY > 1 ? 'add' : 'remove']('moving')
});

document.addEventListener('DOMContentLoaded', () => {
  const stimulus = Application.start()
  stimulus.register("download", DownloadController)
  stimulus.register('download-section', DownloadSectionController)
  stimulus.register('pricing', PricingController)
  stimulus.register('os', OSController)
  stimulus.register('gateway', GatewayController)
  stimulus.register('linux', LinuxController)
  stimulus.register('exit', ExitController)
  stimulus.register('tracker', TrackerController)
  stimulus.register('analytics', AnalyticsController)
  stimulus.register('modal', ModalController)
  stimulus.register('expander', ExpanderController)
  stimulus.register('blog-modal', BlogModalController)
  stimulus.register('videos', VideosController)
  stimulus.register('clipboard', ClipboardController)
  stimulus.register('sales-qualifier', SalesQualifierController)
  stimulus.register('autoplay-video', AutoplayVideoController)
  stimulus.register('language-suggest', LanguageSuggestController)
  stimulus.register('testimonial-form', TestimonialFormController)
  stimulus.register('testimonial-filter', TestimonialFilterController)
  stimulus.register('plugin-directory', PluginDirectoryController)
  stimulus.register('video-play', VideoPlayController)

  configureHoneybadger()
})


// Fathom counts the page a visit lands on by itself (data-auto, head.html),
// and its script has already run by the first turbo:load, so only the Turbo
// visits after that are counted here.
let landed = false

document.addEventListener('turbo:load', () => {

  if (!landed) {
    landed = true
  } else if (window.fathom) {
    window.fathom.trackPageview()
  } else if (window.jekyllEnv === 'development') {
    console.log('DEV trackPageView')
  } else {
    console.warn("F not available")
  }

  $("[data-tooltip!=''][data-tooltip]").tooltip();

  $('.dropdown-trigger').dropdown();
  $('.navbar-dropdown-trigger').dropdown({
    constrainWidth: false,
    hover: true,
    coverTrigger: false
  })

  //GLightbox
  const lightbox = GLightbox();


  // Swiper
  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    centeredSlides: true,
    grabCursor: true,
    loop: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    // Not in the translation review app: a translator reads the slides.
    autoplay: reviewFrame ? false : {
      delay: 6000,
      disableOnInteraction: false,
      stopOnLastSlide: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
});

// main.js is deferred (head.html), so the document is already "interactive"
// when Turbo starts, and Turbo 8.0.23 only learns that from the
// readystatechange event it has missed. Left alone, it fires the first
// turbo:load at readyState "complete", once every image and iframe on the
// page has loaded, and the menus, lightbox and carousel above wait for that.
// Tell it now, as a blocking script would have let it see for itself.
if (document.readyState === 'interactive') {
  Turbo.session.pageObserver.pageIsInteractive()
}
